<template>
<v-container fluid>
    <v-row>
        <v-col>
            <v-card>
                <v-card-title>
                    <div style="flex: 1">
                        Filtros
                    </div>
                    <div>
                        <v-tabs v-model="sistema_type">
                            <v-tab tab-value="sistema">Sistemas</v-tab>
                            <v-tab tab-value="app">Aplicaciones</v-tab>
                        </v-tabs>
                    </div>
                </v-card-title>
                <v-card-text>
                    <TicketSearch 
                        context="sistema" 
                        :loading="loading" 
                        :default="params" 
                        @search="params = $event"
                        :sistema_type="sistema_type"
                        />
                </v-card-text>
            </v-card>
            <TicketList context="sistema" :params="params" :loading="loading"/>
        </v-col>
    </v-row>
</v-container>
</template>
    
<script>
import TicketSearch from '@components/entities/ticket/search';
import TicketList from '@components/entities/ticket';

export default {
    components: {
        TicketSearch,
        TicketList,
    },
    data: function () {
        const defaultParams = this.setQuery({
            date: this.$luxon.local().toISODate(),
        });
        return {
            options: {},
            loading: false,

            isModalOpen: false,
            item: null,

            default: defaultParams,
            params: {...defaultParams},

            sistema_type: 'sistema',
        };
    },
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', 'Admin. de Tickets Sistema');
    },
    methods: {
        add: function () {
            this.item = null;
            this.isModalOpen = true;
        },
        edit: function (item) {
            this.item = item;
            this.isModalOpen = true;
        },
        setQuery: function (params = {}) {
            const query = {... this.$route.query};

            for (const key in query) {
                if (Object.hasOwnProperty.call(query, key)) {
                    const element = query[key];

                    if (key == 'numero') {
                        query[key] = element;
                        continue;
                    }

                    query[key] = /^-?[\d.]+(?:e-?\d+)?$/.test(element) ? Number.parseFloat(element): element;
                }
            }

            return { ... params, ... query };
        },
    },
}
</script>